const DIRECTORY_PROMOTIONS_ROUTES = {
    path: 'directory/promotions',
    name: 'directory-promotions',
    redirect: { name: 'promotions-list' },
    component: () => import('@/views/pages/Directories/goods/promotions/DirectoryGoodsPromotionsPage.vue'),
    children: [
        {
            path: 'list',
            name: 'promotions-list',
            meta: { transition: 'slide-left' },
            component: () => import('@/views/pages/Directories/goods/promotions/list/DirectoryGoodsPromotionsListPage.vue')
        },
        {
            path: ':promotionId',
            name: 'current-promotion-promotion',
            meta: { transition: 'slide-right' },
            redirect: { name: 'current-promotion' },
            component: () => import('@/views/pages/Directories/goods/promotions/current/DirectoryGoodsPromotionsCurrentPage.vue'),
            children: [
                {
                    path: 'promotion',
                    name: 'current-promotion',
                    component: () => import('@/views/pages/Directories/goods/promotions/current/tabs/basic/tab.tsx')
                },
                {
                    path: 'promotingGoods',
                    name: 'current-promotion-goods',
                    component: () => import('@/views/pages/Directories/goods/promotions/current/tabs/promotingGoods/tab.tsx')
                },
                {
                    path: 'replacement',
                    name: 'current-promotion-replacement',
                    component: () => import('@/views/pages/Directories/goods/promotions/current/tabs/replacement/tab')
                },
                {
                    path: 'visual',
                    name: 'current-promotion-visual',
                    component: () => import('@/views/pages/Directories/goods/promotions/current/tabs/visual/tab')
                },
            ]
        }
    ]
};

export default DIRECTORY_PROMOTIONS_ROUTES;
